import { render, staticRenderFns } from "./NotePane.vue?vue&type=template&id=ab249c24"
import script from "./NotePane.vue?vue&type=script&lang=js"
export * from "./NotePane.vue?vue&type=script&lang=js"
import style0 from "./NotePane.vue?vue&type=style&index=0&id=ab249c24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports